import api from './index';

type PostLoginData = { username: string; password: string; _token?: string };
const postLogin = (props: PostLoginData) => {
  return api.post(`/login`, props);
};

type PostPasswordResetData = { username: string; _token?: string };
const postPasswordReset = (props: PostPasswordResetData) => {
  return api.post(`/forgot-password`, props);
};

type PostPasswordResetSubmissionData = {
  password: string;
  password_confirmation: string;
  username?: string;
  _token?: string;
  token?: string;
};
const postPasswordResetSubmission = (props: PostPasswordResetSubmissionData) => {
  return api.post(`/forgot-password-submission`, props);
};

type PostForgotCredentialsData = { username: string; _token?: string };
const postForgotCredentials = (props: PostForgotCredentialsData) => {
  return api.post(`/forgot-username`, props);
};

export const AuthService = {
  postLogin,
  postPasswordReset,
  postPasswordResetSubmission,
  postForgotCredentials,
};
